/* eslint-disable */
export default {
  save: 'Salva',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
